<template>
  <div class="orderList">
    <a-breadcrumb class='breadcrumb'>
      <template #separator><span style="color: #000">></span></template>
      <a-breadcrumb-item v-for="(item,index) in breadcrumbList" :key="index" @click='toHref(item.href)'>{{item.name}}</a-breadcrumb-item>
    </a-breadcrumb>
    <a-row :gutter="80" class="content">
      <a-col class="gutter-row left" :span="4">
       
        <div class="gutter-box">
          <df-menu ></df-menu>
        </div>
      </a-col>
      <a-col class="gutter-row" :span="20" style='padding-right:0'>
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <!-- <keep-alive :include='keepAlive'> -->
              <component :is="Component"/>
            <!-- </keep-alive> -->
          </transition >

        </router-view>   
      </a-col>
    </a-row>
   
      
    <!-- <router-view class="Site-content"></router-view> -->
  </div>
</template>

<script>
import { useRoute,useRouter } from 'vue-router'
import { watch,computed } from 'vue'
import breadcrumb from '@assets/js/breadcrumb'

export default {
  name: 'my',
  components: {

  },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const { currentRoute } = useRouter();

    let breadcrumbList = computed(()=>{

      return  breadcrumb[currentRoute.value.name]

    })

    const toHref = (href) => {
      if(href == currentRoute.value.name){
        return;
      }
      router.push({
        name : href
      })
    }

    return {
      breadcrumbList,
      toHref,
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .breadcrumb{
    height: 25px;
    line-height: 25px;
    margin-bottom: 19px;

  }
  .content {
    margin: 0 !important;
    .left {
      background: #f8f8f8;
      min-height: 1600px;
      padding: 0 !important;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
      ::v-deep(.ant-menu){
        background-color: #f8f8f8;
      }
    }
  }
  .orderList {
    width: 1200px;
    margin: 0 auto;
    padding: 25px 0px;

    box-sizing: border-box;
    font-size: 14px;
  
  }
</style>
